import { LOADING } from '../constants'

export const loading = (payload) => ({
    type: LOADING,
    payload
})